import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e23fd84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-1" }
const _hoisted_2 = { class: "flex gap-1" }
const _hoisted_3 = { class: "flex gap-2 items-center justify-between" }
const _hoisted_4 = { class: "w-36" }
const _hoisted_5 = { class: "flex gap-1 items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RfpCategorySelect = _resolveComponent("RfpCategorySelect")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        class: "form-input p-2 w-full",
        type: "search",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.search) = $event)),
        "aria-label": "Søk etter rapporter",
        id: "search",
        placeholder: "Søk"
      }, null, 512), [
        [_vModelText, _ctx.data.search]
      ]),
      _createVNode(_component_RfpCategorySelect, {
        placeholder: "Filtrer på kategorier",
        modelValue: _ctx.data.category_ids,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.category_ids) = $event)),
        categories: _ctx.allCategories
      }, null, 8, ["modelValue", "categories"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Multiselect, {
            id: "filterSelect",
            modelValue: _ctx.data.filteredBy,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.filteredBy) = $event)),
            options: _ctx.options,
            label: "label",
            valueProp: "value",
            canDeselect: false,
            canClear: false
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Checkbox, {
            label: "Vis lukkede",
            modelValue: _ctx.data.showClosed,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.showClosed) = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _hoisted_6
  ]))
}